import { html } from "lit-html"

const TagList = (tags) => {
  const primaryTags = tags.filter((tag) => !("primary" in tag) || tag.primary)
  return primaryTags.map(
    (tag, idx) => html`
      <span class="inline-block text-tag-text-${tag.color.toLowerCase()}">
        ${tag.name}${idx < primaryTags.length - 1 ? html` ,&nbsp; ` : ""}
      </span>
    `
  )
}

export default TagList
